import req from "@/utils/axios.js";

export default {
    // 获取我的部门信息
    getMyDepartment(data) {
        return req.post("/wxShop/getMyDepartment", {
            ...data
        })
    },
    // 获取分部的部门uuid
    getFirmRegionDepartment(data) {
        return req.get("/wxShop/department/getFirmRegionDepartment", {
            ...data
        })
    },
    // 获取部门和岗位信息
    getDepartmentInfo(data) {
        return req.get("/wxShop/department/getDepartment", {
            ...data
        })
    },
    // 获取部门下级信息
    getDepartmentLowerLevel(data) {
        return req.post("/wxShop/department/lowerRecursion", {
            ...data
        })
    },

    // 列表
    // getDepartmentList(data) {
    //     return req.get("/shopManager/department/list", {
    //         ...data
    //     })
    // },
    // // 列表递归
    // getDepartmentListRecursion(data) {
    //     return req.get("/shopManager/department/listRecursion", {
    //         ...data
    //     })
    // },

    // // 获取部门上级信息
    // getDepartmentUpperLevel(data) {
    //     return req.post("/shopManager/department/getUpperLevel", {
    //         ...data
    //     })
    // },
    // // 获取部门下级信息
    // getDepartmentLowerLevel(data) {
    //     return req.post("/shopManager/department/getLowerLevel", {
    //         ...data
    //     })
    // },
    // getMyLowerLevel(data) {
    //     return req.post("/shopManager/department/getMyLowerLevel", {
    //         ...data
    //     })
    // },
    // // 获取部门下员工列表
    // getDepartmentShopClerkList(data) {
    //     return req.post("/shopManager/department/getShopClerkList", {
    //         ...data
    //     })
    // },

    // // 获取部门信息
    // getDepartmentListAll(data) {
    //     return req.get("/shopManager/department/departmentList", {
    //         ...data
    //     })
    // },

}
